<template>
  <div v-if="chosenChildOrg && childOrgsSelector && componentName">
    <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: center">
      <v-btn
        v-if="componentName !== 'form1a' && componentName !== 'form1b' && componentName !== 'form1c'"
        dense class="button white__v-btn mr-2" :to="'/forms/form-' + prevFormName"
      >
        Предыдущая форма
      </v-btn>
      <div class="structural-unit">
        <label>Выбор структурного подразделения</label>
        <!--        clearable-->
        <v-autocomplete
          v-model="selectorId"
          :items="childOrgsSelector"
          @change="selectOrganization(selectorId)"
          dense
          outlined
        ></v-autocomplete>
      </div>
      <v-btn
        v-if="componentName !== 'form22'"
        dense class="button white__v-btn" :to="'/forms/form-' + nextFormName"
      >
        Следующая форма
      </v-btn>
    </div>
    <header-main class="fives-forms" :title="textBodyHeader" :subtitle="subtextBodyHeader">
      <template v-if="thirdText">
        <span style="color: #00599B; font-size: 12px">{{ thirdText }}</span>
      </template>
    </header-main>
    <component :is="componentName" :organizationBlocked="organizationBlocked" :chosenChildOrg="chosenChildOrg"
               :text-body-header="textBodyHeader"/>
  </div>
</template>

<script>
import inProgress from '@/components/InProgress';
import form1a from '@/pages/Organization/Forms5/form5_1a';
import form1b from '@/pages/Organization/Forms5/form5_1b';
import form1c from '@/pages/Organization/Forms5/form5_1c';
// import form2 from '@/pages/Organization/Forms5/form5_2';
// import form5b from '@/pages/Organization/Forms5/form5b'
// import form5c from '@/pages/Organization/Forms5/form5c'
import form3 from '@/pages/Organization/Forms5/form5_3';
import form4 from '@/pages/Organization/Forms5/form5_4';
import form5 from "@/pages/Organization/Forms5/form5";
import form6 from "@/pages/Organization/Forms5/form6";
import form7 from "@/pages/Organization/Forms5/form7";
import form8 from "@/pages/Organization/Forms5/form8";
import form9 from "@/pages/Organization/Forms5/form9";
import form10 from "@/pages/Organization/Forms5/form10";
import form11 from "@/pages/Organization/Forms5/form11";
// import form12a from "@/pages/Organization/Forms5/form12a";
// import form12b from "@/pages/Organization/Forms5/form12b";
import form13 from "@/pages/Organization/Forms5/form13";
import form14 from "@/pages/Organization/Forms5/form14";
import form15 from "@/pages/Organization/Forms5/form15";
import form16 from "@/pages/Organization/Forms5/form16";
import form17 from "@/pages/Organization/Forms5/form17";
import form18 from "@/pages/Organization/Forms5/form18";
import form19 from "@/pages/Organization/Forms5/form19";
import form20 from "@/pages/Organization/Forms5/form20";
import form21 from "@/pages/Organization/Forms5/form21";
import form22 from "@/pages/Organization/Forms5/form22";
import HeaderMain from "@/components/headers/HeaderMain";
import allForms from "@/pages/Organization/Forms5/allForms";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "allFifthForms",
  components: {
    HeaderMain, inProgress, form1a, form1b, form1c, /*form2,*/ form3,
    form4, form5, form6, form7, form8, form9, form10, form11, form13,
    form14, form15, form16, form17, form18, form19, form20, form21, form22
  },
  data() {
    return {
      componentName: 'inProgress',
      textBodyHeader: '',
      subtextBodyHeader: '',
      thirdText: '',
      defaultComponent: {name: 'inProgress', formId: 'inProgress', text: 'В процессе разработки'},
      componentsData: allForms,
      childOrgs: [],
      childOrgsSelector: [],
      chosenChildOrg: null,
      selectorId: null,
    }
  },
  
  computed: {
    ...mapGetters('spr', {getAvailableOrgs: 'getAvailableOrgs'}),
    ...mapGetters('checkFilled', {organizationBlocked: 'organizationBlocked'}),
    
    prevFormName() {
      if (this.componentName.slice(4) === '3') {
        let path;
        switch (this.chosenChildOrg?.type?.id) {
          case 1:
            path = '1a'
            break
          case 2:
            path = '1b'
            break
          case 3:
            path = '1c'
            break
        }
        return path
      } else if (this.componentName.slice(4) === '13') {
        return '11'
      } else {
        return String(Number(this.componentName.slice(4)) - 1)
      }
    },
    
    nextFormName() {
      if (['1a', '1b', '1c'].includes(this.componentName.slice(4))) {
        return '3'
      } else if (this.componentName.slice(4) === '11') {
        return '13'
      } else {
        return String(Number(this.componentName.slice(4)) + 1)
      }
    }
  },
  
  created() {
    this.initComponent();
  },
  
  watch: {
    $route() {
      this.initComponent();
    },
    getAvailableOrgs() {
      this.initComponent();
    }
  },
  
  methods: {
    ...mapActions('spr', {changeSelectedOrg: 'changeSelectedOrg'}),
    initComponent() {
      const form = this.$route.params.form_id;
      const component = this.componentsData.find(el => form === el.formId);
      this.componentName = component?.name ?? this.defaultComponent.name;
      // console.log(this.componentName.slice(4));
      this.textBodyHeader = component?.text + ' ' + component?.textBodyHeader;
      this.subtextBodyHeader = component?.subtextBodyHeader;
      this.thirdText = component?.html;
      this.$route.meta.title = (component?.text + component?.textBodyHeader) ?? this.defaultComponent.text;
      
      if (this.chosenChildOrg === null || this.chosenChildOrg === undefined) {//первая загрузка
        this.childOrgs = this.getAvailableOrgs;
        this.childOrgsSelector = this.getAvailableOrgs.map((el) => {
          return {
            text: el.name,
            value: el?.id,
          }
        });
        this.selectorId = this.childOrgs[0]?.id;
        this.chosenChildOrg = this.childOrgs[0];
        this.changeSelectedOrg(this.chosenChildOrg);
      }
    },
    
    selectOrganization(orgId) {
      // TODO почему-то присваивает первому элементу childOrgs id из селектора
      if (orgId) {
        this.chosenChildOrg = this.childOrgs.find(el => el?.id === orgId);
        this.changeSelectedOrg(this.chosenChildOrg);
      }
    },
  },
}
</script>

<style scoped>

</style>